import { render, staticRenderFns } from "./enderecoEntregaTerceiro.vue?vue&type=template&id=40d05bca"
import script from "./enderecoEntregaTerceiro.ts?vue&type=script&lang=js&external"
export * from "./enderecoEntregaTerceiro.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d05bca')) {
      api.createRecord('40d05bca', component.options)
    } else {
      api.reload('40d05bca', component.options)
    }
    module.hot.accept("./enderecoEntregaTerceiro.vue?vue&type=template&id=40d05bca", function () {
      api.rerender('40d05bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/enderecoEntregaTerceiro.vue"
export default component.exports